export default "__VITE_ASSET__bacc9800__"